module.exports = (state, action) => {
  const box = action.payload
  const { boxId, labels } = box
  if (boxId !== undefined) {
    state.boxes[boxId].boxlabels = labels
    return state
  } else {
    throw new Error('Cannot edit box with id: undefined')
  }
}
